
import { Button } from "@/components/ui/button";
import { Image, Trash2 } from "lucide-react";

interface UploadActionsProps {
  avatar_url: string;
  isLoading: boolean;
  onImageUpload: (event: React.ChangeEvent<HTMLInputElement>) => Promise<void>;
  onDeleteAvatar: () => Promise<void>;
}

export function UploadActions({ 
  avatar_url, 
  isLoading, 
  onImageUpload, 
  onDeleteAvatar 
}: UploadActionsProps) {
  return (
    <div className="flex gap-2">
      <Button
        variant="outline"
        size="sm"
        type="button"
        disabled={isLoading}
      >
        <label className="cursor-pointer flex items-center gap-1">
          <Image className="h-3 w-3" />
          <span className="text-xs">Upload</span>
          <input
            type="file"
            className="hidden"
            accept="image/*"
            onChange={onImageUpload}
            disabled={isLoading}
          />
        </label>
      </Button>
      {avatar_url && avatar_url !== "/placeholder.svg" && (
        <Button
          variant="outline"
          size="sm"
          onClick={onDeleteAvatar}
          type="button"
          disabled={isLoading}
          className="text-red-400 hover:text-red-300 hover:bg-red-400/10"
        >
          <Trash2 className="h-3 w-3 mr-1" />
          <span className="text-xs">Remove</span>
        </Button>
      )}
    </div>
  );
}
